import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";
import { breadcrumbFor, type RouteKey } from "@/lib/routes";

export function Breadcrumbs({ current }: { current: RouteKey }) {
  const { t, path } = useT();
  const chain = breadcrumbFor(current);
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-eyebrow text-slate2"
      data-testid="breadcrumbs"
    >
      {chain.map((k, idx) => {
        const isLast = idx === chain.length - 1;
        const label = t.routes[k].label;
        return (
          <span key={k} className="flex items-center gap-2">
            {isLast ? (
              <span aria-current="page" className="text-ink">{label}</span>
            ) : (
              <Link to={path(k)} className="hover:text-clay transition-colors">
                {label}
              </Link>
            )}
            {!isLast && <ChevronRight size={11} className="opacity-50" aria-hidden />}
          </span>
        );
      })}
    </nav>
  );
}
